"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _FormatDateOfBirth = require("../../../../utils/FormatDateOfBirth");
var _info_icon = require("../../../atoms/icons/info_icon");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _text_input = require("../../text_input");
var _ValidateDateOfBirth = require("../../../../utils/ValidateDateOfBirth");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DateOfBirthInput = function DateOfBirthInput(_ref) {
  var register = _ref.register,
    errors = _ref.errors;
  var error = false;
  var helperText = '';
  if (errors.date) {
    error = true;
    helperText = errors.date.message;
  }
  var handleDateInput = function handleDateInput(e) {
    var inputField = e.target;
    var inputValue = e.target.value;
    var output = (0, _FormatDateOfBirth.FormatDateOfBirth)(inputValue);
    inputField.value = output;
  };
  return /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    cypressClass: "date-of-birth",
    type: "text",
    maxLength: 10,
    onChange: handleDateInput,
    label: "Date of birth (dd/mm/yyyy)",
    name: "date",
    icon: error ? /*#__PURE__*/_react["default"].createElement(_info_icon.InfoIcon, {
      fill: "#ee0033"
    }) : null,
    error: error,
    helperText: helperText,
    register: register({
      required: 'Missing DOB',
      pattern: {
        value: /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/]\d{4}$/i,
        message: 'Please make sure to follow this date format DD/MM/YYYY'
      },
      validate: {
        legalAge: function legalAge(value) {
          return (0, _ValidateDateOfBirth.ValidateDateOfBirth)(value);
        }
      }
    })
  });
};
DateOfBirthInput.defaultProps = {
  errors: {},
  register: function register() {}
};
DateOfBirthInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,
  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = DateOfBirthInput;